<template>
  <div>
    <!--头部-->
    <HeaderForPlay :showValue="6"></HeaderForPlay>
    <!-- background:#E6E6E6; -->
     <div class="jqgk" style=";padding-left:20px;padding-right:20px">
      <div class="contai" style="max-width:1197px;margin-top:-80px;background:#fff">
        <div style="margin:90px 0px 10px 10px;">
          <span v-if="pcshow" class="titleFont">{{ title }}</span>
          <span v-if="!pcshow" class="titleFontFm">{{ title }}</span>
          <div style="height:1px"></div>
          <div v-if="pcshow" style="text-align:left;margin-top:80px;;padding:0 20px">
            <div v-for="item in list" :key="item.key">
              <div v-if="item.type == 3" >
                <p v-html="item.content" ></p>
              </div>
              <img
                v-if="item.type == 2"
                :src="item.content"
                style="width:100%"
              />
              <span
                v-if="item.type == 1"
                class="titleCelebrityFont"
                style="padding-top:0px"
              >
                {{ item.content }}
              </span>
            </div>
          </div>

          <div v-if="!pcshow" style="text-align:left;margin-top:20px">
            <div v-for="item in list" :key="item.key">
              <div v-if="item.type == 3" >
                <p v-html="item.content" ></p>
              </div>
              <img
                v-if="item.type == 2"
                :src="item.content"
                style="width:100%;margin-top:10px"
              />
              <span
                v-if="item.type == 1"
                class="titleCelebrityFontFm"
                style="padding-top:0px"
              >
                {{ item.content }}
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderForPlay from './headerforplay'
import Footer from './footer'
export default {
  components: { HeaderForPlay, Footer },
  data () {
    return {
      type: 1,
      title: '',
      list: [],
      pcshow: false
    }
  },
  beforeCreate () {},
  created () {
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
    let info = this.$route.query.id
    if (info.title == undefined) {
      this.$router.push({
        path: '/PlayAllOverForHappy'
      })
    } else {
      this.title = info.title
      this.list = JSON.parse(info.details)
    }
  },
  //  监听路由变化
  watch: {
    $route (to, from) {
      let info = to.query.id
      this.title = info.title
      this.list = JSON.parse(info.details)
    }
  },
  mounted () {},

  methods: {
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }

  }
}
</script>

<style>

.titleFontFm {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  margin-top: 70px;
}

.titleFont {
  font-size: 42px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  margin-bottom: 10px;
}

.titleFontSpan {
  font-size: 16px;
  font-family: "Adobe Heiti Std";
  font-weight: normal;
  color: #333333;
  line-height: 30px;
  text-indent: 2em;
}
.titleCelebrityFontFm{
  font-size: 14px;
  font-weight: 400;
  color: #2c3030;
  line-height: 36px;
  margin: 0px;
  padding: 0px;
  text-indent: 2em;
}
.titleCelebrityFont{
  font-size: 18px;
  font-weight: 400;
  color: #2c3030;
  line-height: 36px;
  margin: 0px;
  padding: 0px;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/sceneryInfomationForwanbianHappy.vue